export const UNIT_LABEL = { g: "g", kg: "kg", mg: "mg", ml: "mL", cl: "cL", l: "L", piece: "pièce(s)", pack: "conditionnement(s)" };
export const BASE_UNITS = [["g", "Poids (g)"], ["ml", "Volume (mL)"], ["piece", "Unité / pièce"]];
export const UNITS_FOR = { g: ["g", "kg"], ml: ["ml", "cl", "l"], piece: ["piece"] };
export const CATEGORIES = ["Viandes", "Poissons", "Légumes", "Fruits", "Produits laitiers", "Féculents", "Sauces & condiments", "Boissons", "Desserts", "Préparations maison", "Emballages & consommables", "Autre"];
export const MOVEMENT_TYPES = {
  in_purchase: { label: "Entrée (achat / livraison)", sign: 1, staff: false },
  in_return: { label: "Retour en stock", sign: 1, staff: false },
  in_adjust: { label: "Correction + (justifiée)", sign: 1, staff: false },
  out_sale: { label: "Consommation (vente)", sign: -1, staff: false, auto: true },
  out_waste: { label: "Perte : casse / gaspillage", sign: -1, staff: true },
  out_expired: { label: "Perte : périmé", sign: -1, staff: true },
  out_staff_meal: { label: "Repas du personnel", sign: -1, staff: true },
  out_prep_error: { label: "Erreur de préparation", sign: -1, staff: true },
  out_adjust: { label: "Correction − (justifiée)", sign: -1, staff: false },
  adjust_inventory: { label: "Inventaire (stock compté)", sign: 0, staff: false },
};

// Affiche une quantité en unité de base de façon lisible (g→kg, mL→L au-delà de 1000).
export function fmtQty(q, baseUnit) {
  const n = Number(q || 0);
  if (baseUnit === "g") return Math.abs(n) >= 1000 ? `${(n / 1000).toLocaleString("fr-FR", { maximumFractionDigits: 2 })} kg` : `${n.toLocaleString("fr-FR", { maximumFractionDigits: 0 })} g`;
  if (baseUnit === "ml") return Math.abs(n) >= 1000 ? `${(n / 1000).toLocaleString("fr-FR", { maximumFractionDigits: 2 })} L` : `${n.toLocaleString("fr-FR", { maximumFractionDigits: 0 })} mL`;
  return `${n.toLocaleString("fr-FR", { maximumFractionDigits: 2 })} pc`;
}
